module.exports = __webpack_public_path__ + "static/media/caution2.fa950ef5.png";